import { createAction } from 'redux-act'

export function createFetchAction(actionName: string) {
  return [
    createAction<any>(actionName),
    createAction<any>(`${actionName}Success`),
    createAction<any>(`${actionName}Failure`),
  ]
}
